import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "lottery-combos-picker",
  "data-test": "combinations-board"
}

import DsCheckboxOption from "@sazka/design-system/src/forms/components/ds-checkbox-option.vue";
import { KAMENY_COMBOS } from "../data/kameny-constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'lottery-combos-picker',
  props: /*@__PURE__*/_mergeModels({
    showMultiplier: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["comboPicked"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const model = _useModel<number[]>(__props, "modelValue");



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(KAMENY_COMBOS), (combo) => {
      return (_openBlock(), _createBlock(DsCheckboxOption, {
        class: "lottery-combos-picker__cell",
        key: `combo-${combo.id}`,
        id: `combo-${combo.id}`,
        name: `combo-${combo.id}`,
        label: combo.text,
        "supporting-text": 
                _ctx.showMultiplier ? combo.multiplier.toLocaleString('en').replace(/,/g, '\u00A0') + 'x' : null
            ,
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        value: combo.id,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('comboPicked'))),
        "data-test-label": "combination",
        "data-test-value-input": combo.text
      }, null, 8, ["id", "name", "label", "supporting-text", "modelValue", "value", "data-test-value-input"]))
    }), 128))
  ]))
}
}

})